import React from "react";
import { Grid } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Select, Input } from "../../components/Common";
import { TranslateW } from "../../Utils/Languages/Translate";
import { trakrefFontFamily } from "../../utils";
import Enums from "../../enums";

import "./Profile.css";
import UserInfo from "../../UserInfo";

const {
    SuperTenantAdmin,
    TenantAdministrator,
    RegionalAdministrator,
    TechnicianManager,
    Technician,
    ReadOnly
} = Enums.UserTypes;

const CustomCheckbox = ({ label, checked, onChange }) => (
    <FormControlLabel
        value="end"
        sx={{
            padding: "0px",
            margin: "0px",
        }}
        control={
            <Checkbox
                sx={{
                    paddingLeft: "0px",
                    "&.Mui-checked": {
                        color: "#008299",
                    },
                }}
                checked={checked}
                onChange={onChange}
            />
        }
        label={label}
        labelPlacement="end"
    />
);

const userTypeOptions = [{
    id: SuperTenantAdmin,
    name: 'Super Tenant Administrator'
}, {
    id: TenantAdministrator,
    name: 'Tenant Administrator'
}, {
    id: RegionalAdministrator,
    name: 'Regional Administrator'
}, {
    id: TechnicianManager,
    name: 'Technician Manager'
}, {
    id: Technician,
    name: 'Technician'
}, {
    id: ReadOnly,
    name: 'ReadOnly'
}]

const EditProfileSettings = ({
    userInfo,
    onHandleValueChanged,
    options,
    isCertificationNumberValid,
}) => {
    const isTechnicianInformationVisible =
        UserInfo.isTechnician() ||
        UserInfo.isTechnicianManager() ||
        UserInfo.isSuperTenantAdmin() ||
        UserInfo.isTenantAdministrator();

    const isHasMutlipleAccountVisible =
        UserInfo.isSystemAdministrator() ||
        UserInfo.isTenantAdministrator() ||
        UserInfo.isSuperTenantAdmin();

    return (
        <Grid container spacing={3}>
            <Grid item xs={6} md={6}>
                <Select
                    disabled={!UserInfo.isSystemAdministrator()}
                    value={userInfo.userType}
                    label={TranslateW("Profile.UserType")}
                    options={options.group || userTypeOptions}
                    onChange={(e) => onHandleValueChanged("userType", e.target.value)}
                />
            </Grid>
            <Grid item xs={6} md={6}>
                <Select
                    value={userInfo.language}
                    label={TranslateW("Profile.Language")}
                    options={options.language}
                    onChange={(e) => onHandleValueChanged("language", e.target.value)}
                />
            </Grid>
            {isTechnicianInformationVisible && (
                <Grid item xs={6} md={6}>
                    <Select
                        value={userInfo.certificationTypeID}
                        label={TranslateW("Profile.TechnicianCertificationType")}
                        options={options.certificationType}
                        onChange={(e) =>
                            onHandleValueChanged("certificationTypeID", e.target.value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={6} md={6}>
                <Select
                    value={userInfo.notificationTypeId}
                    label={TranslateW("Profile.Notification")}
                    options={options.notificationType}
                    onChange={(e) =>
                        onHandleValueChanged("notificationTypeId", e.target.value)
                    }
                />
            </Grid>
            {isTechnicianInformationVisible && (
                <Grid item xs={6} md={6}>
                    <Input
                        type="number"
                        fullWidth
                        value={userInfo.certificationNumber}
                        label={TranslateW("Profile.TechnicianCertificationNumber")}
                        error={!isCertificationNumberValid}
                        helperText={"Invalid Certification Number"}
                        onChange={(e) =>
                            onHandleValueChanged("certificationNumber", e.target.value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={6} md={6}>
                <Select
                    value={userInfo.weightUnits}
                    label={TranslateW("Profile.Weightsin")}
                    options={options.weightUnit}
                    onChange={(e) => onHandleValueChanged("weightUnits", e.target.value)}
                />
            </Grid>
            {isTechnicianInformationVisible && (
                <Grid item xs={6} md={6}>
                    <Input
                        fullWidth
                        value={userInfo.technicianTruck}
                        label={TranslateW("Profile.TechnicianTruck")}
                        onChange={(e) =>
                            onHandleValueChanged("technicianTruck", e.target.value)
                        }
                    />
                </Grid>
            )}
            {isTechnicianInformationVisible && (
                <Grid item xs={6} md={6}>
                    <Select
                        value={userInfo.preferredLeakDetectionMethodID}
                        label={TranslateW("Profile.PreferredLeakDetectionMethod")}
                        options={options.leakDetectionMethod}
                        onChange={(e) =>
                            onHandleValueChanged(
                                "preferredLeakDetectionMethodID",
                                e.target.value
                            )
                        }
                    />
                </Grid>
            )}
            <Grid item xs={6} md={6}>
                <>
                    <CustomCheckbox
                        onChange={(e) =>
                            onHandleValueChanged("isReseller", e.target.checked)
                        }
                        checked={userInfo.isReseller}
                        label={<span style={{ fontFamily: trakrefFontFamily }}>{TranslateW("Profile.IsResell")}</span>}
                    />
                    {isHasMutlipleAccountVisible && (
                        <CustomCheckbox
                            onChange={(e) =>
                                onHandleValueChanged("hasOtherInstances", e.target.checked)
                            }
                            checked={userInfo.hasOtherInstances}
                            label={<span style={{ fontFamily: trakrefFontFamily }}>{TranslateW("Profile.MultipleAccount")}</span>}
                        />
                    )}
                </>
            </Grid>
        </Grid>
    );
};

export default EditProfileSettings;
